import {
    YearPickerInput as MantineYearPickerInput,
    YearPickerInputProps as MantineYearPickerInputProps,
    DatePickerType,
} from '@mantine/dates';

/**
 * TODO: Look into how to properly transpile css module imports
 * so we can use absolute import paths. For now, using relative paths.
 */
import inputStyles from '../../styles/Input.module.css';
import datePickerStyles from '../styles/DatePicker.module.css';
import { handleGetYearControlProps } from 'components/dates/utils';

export type YearPickerInputProps<Type extends DatePickerType = 'default'> = MantineYearPickerInputProps<Type>;

export const YearPickerInput = <Type extends DatePickerType = 'default'>({
    type = 'default',
    ...props
}: YearPickerInputProps<Type>) => {
    return (
        <MantineYearPickerInput
            type={type}
            classNames={{
                input: inputStyles.input,
                label: inputStyles.label,
                description: inputStyles.description,
                required: inputStyles.required,
                yearsListControl: datePickerStyles.yearsListControl,
            }}
            getYearControlProps={handleGetYearControlProps}
            {...props}
        />
    );
};
